import styled from 'styled-components';
import { color, space, font, query } from '@design/templateFns';

export const GridContainer = styled.div`
  background-color: ${color('secondaryBg')};
  padding: ${space('x6')} ${space('marginMobile')} ${space('x10')};

  @media screen and (${query.atLeast('tablet')}) {
    display: flex;
    padding: 0;
  }
`;

export const ContentContainer = styled.div`
  padding-top: ${space('x6')};

  @media screen and (${query.atLeast('tablet')}) {
    padding: ${space('xl')};
    align-self: center;
  }

  @media screen and (${query.atLeast('desktop')}) {
    max-width: 585px;
    padding: ${space('x6')} ${space('x10')};
  }
`;

export const Header = styled.h2`
  ${font('subhead-lg')};
  margin: 0 0 ${space('x5')};
  padding: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('subhead-xl')};
    margin: 0 0 ${space('xl')};
  }
`;

export const Text = styled.p`
  ${font('body-sm-light')};
  padding-bottom: 28px; // unique to match figma

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
    padding-bottom: ${space('x7')};
  }
`;

export const ImageBox = styled.div`
  width: 100%;
  position: relative;
  height: 0;
  padding-bottom: 77.5%;
  img {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media screen and (${query.atLeast('tablet')}) {
    height: 306px;
    width: 50%;
    flex-shrink: 0;
    padding-bottom: 0;
  }
  @media screen and (${query.atLeast('desktop')}) {
    height: 306px;
    max-width: 408px;
  }
`;
